import {AuthService} from '@/plugins/auth.service';
import {AxiosRequestConfig} from 'axios';
import {Event, EventBus} from '@/plugins/bus';

export class AxiosAuthHttp {

  public static createNewClient(options) {
    if (options == null) {
      throw new Error('Provided options for auth-http are null!');
    }
    if (options.axios == null) {
      throw new Error('options.axios is required to generate a new http client');
    }
    if (options.resourceId == null) {
      throw new Error('options.resourceId is required to acquire an auth token');
    }

    const axios = options.axios;
    const http = axios.create({
      baseURL: options.baseUrl,
      headers: {
        Authorization: null
      }
    });

    let firstTime: boolean = true;

    http.interceptors.request.use((config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
      return AuthService.getToken().then((token: string) => {
        if (!token) {
          AuthService.login();
          return Promise.reject('No token returned');
        }
        config.headers['Authorization'] = `BEARER ${token}`;

        if (firstTime) {
          EventBus.$emit(Event.UserAuthenticated);
          firstTime = false;
        }
        return config;
      });
    }, error => {
      return Promise.reject(error);
    });

    http.interceptors.response.use(
      (response: any) => {
        return response;
      },
      (error: any) => {
        return Promise.reject(error);
      }
    );

    if (options.router == null) {
      return http;
    }

    //options.router.beforeEach((to: any, from: any, next: any) => {});

    //options.router.afterEach((to: any, from: any) => {});

    return http;
  }
}
